import PropTypes from 'prop-types';
import './FormError.scss';

const FormError = ({ error = '' }) => {
  if (!error) {
    return null;
  }
  return (
    <div data-test="form-error" className="form-error">
      <span>{error}</span>
    </div>
  );
};

FormError.propTypes = {
  error: PropTypes.string
};

export default FormError;
